<template>
  <layout-private :customer="customer">
    <div class="row find-plans">

      <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2 col-md-10 offset-md-1">

        <hr class="hr-salmon">
        <div class="d-flex justify-content-between">
          <h1 v-if="!treatPlans.length">Find Patient Treatment Plans</h1>
          <h1 v-if="treatPlans.length">Treatment Plans</h1>
          <button v-if="treatPlans.length" class="btn btn-link" @click.prevent="clear">clear</button>
        </div>
        

        <div v-if="!treatPlans.length" class="row">
          <div class="col-sm-8 col-12">
            <input v-model.number="patNum" name="patNum" class="form-control" placeholder="Enter Patient Number" type="number" @keyup.enter="loadPlansByPatNum"/>
          </div> <!-- /.col -->
          <div class="col-sm-4 col-12">
            <button v-if="!loading" @click.prevent="loadPlansByPatNum" class="btn btn-green">Search<i class="fas fa-angle-right fa-fw"></i></button>
            <p class="loading-search" v-if="loading"><i class="far fa-fw fa-pulse fa-spinner"></i></p>
          </div> <!-- /.col -->
        </div> <!-- /.row -->

        <p v-if="pat_name" class="small pat-name"><em>results for {{ pat_name }}:</em></p>
        
        <list-errors :errors="errors"></list-errors>

        <div v-if="treatPlans && treatPlans.length" v-for="tPlan in treatPlans" :key="tPlan.TreatPlanNum" class="">
          <button class="btn btn-tplan-select d-flex justify-content-between align-items-center" @click="selectPlan(tPlan)">
            <span>
              <strong>{{ tPlan.SecDateTEdit | prettyDateShortFromDT }}</strong><br>
              <span>{{ tPlan.Heading }}</span>
            </span>
            <i class="fas fa-angle-right"></i>
          </button>
        </div>

        <hr class="hr-green">

      </div> <!-- /.col -->

    </div> <!-- /.row -->
  </layout-private>
</template>

<script>
import Vue from 'vue'
import LayoutPrivate from '../components/LayoutPrivate.vue'
import {mapGetters} from 'vuex'
import ListErrors from '../components/ListErrors.vue'
import store from '../store'

export default {
  props: ['customer'],
  components: {
    LayoutPrivate, ListErrors, 
  },
  data () {
    return {
      errors: [],
      loading: false,
      patNum: null,
      treatPlans: [],
    }
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'custom_claims', 'pat_num', 'pat_name']),
  },
  watch: {
    user (auth) {
      if(auth) {
        
      }
    },
    user_props() {
      if(this.user_props) {

      }
    },
    pat_num() {
      if(this.pat_num) {
        this.patNum = this.pat_num;
      }
    },
  },
  methods: {
    backgroundLoadPatientName() {
      // quietly load patient's name after search initiated
      // validate patNum
      if(!this.patNum || !this.patNum.toString().length > 10 || !Number.isInteger(this.patNum)) {
        return;
      }
      // validate required data exists
      if(!this.custom_claims || !this.custom_claims.customerId || !this.custom_claims.authorized_location || !this.user || !this.user.uid) {
        return;
      }
      // clear any existing name
      if(this.pat_name) {
        store.dispatch('clearPatName');
      }
      var loadPatientNameFunc = Vue.functions.httpsCallable('loadPatientName');
      loadPatientNameFunc({
        patNum: this.patNum,
        customerId: this.custom_claims.customerId,
        uid: this.user.uid,
        locationId: this.custom_claims.authorized_location
      })
        .then(result => {
          // console.log('backgroundLoadPatientName result',result);
          if(result && result.data) {
            store.dispatch('updatePatName', result.data);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    loadPlansByPatNum() {
      this.loading = true;
      this.errors = [];
      // validate patNum
      if(!this.patNum || !this.patNum.toString().length > 10 || !Number.isInteger(this.patNum)) {
        this.errors.push("Invalid Patient Number (PatNum)");
      }
      // validate required data exists
      if(!this.custom_claims || !this.custom_claims.customerId || !this.custom_claims.authorized_location || !this.user || !this.user.uid) {
        this.errors.push("You're missing the permissions to load treatment plans. Please contact a team lead.");
      }
      if(this.errors.length) {
        this.loading = false;
        return;
      }
      // load patient name quietly
      if(!this.pat_name) {
        this.backgroundLoadPatientName();
      }
      this.treatPlans = [];
      // use callable function
      var loadPlansByPatNumFunc = Vue.functions.httpsCallable('loadPlansByPatNum');
      loadPlansByPatNumFunc({
        patNum: this.patNum,
        customerId: this.custom_claims.customerId,
        uid: this.user.uid,
        locationId: this.custom_claims.authorized_location
      })
        .then(result => {
          // console.log('loadPlansByPatNum result',result);
          this.loading = false;
          if(result && result.data && result.data.length) {
            this.treatPlans = result.data;
            store.dispatch('updatePatNum', this.patNum);
          } else {
            this.errors.push("No treatment plans with the status 'saved' found for that Patient Number in Open Dental");
          }
        })
        .catch(err => {
          this.errors.push(err.message)
          this.loading = false;
          console.log(err);
        });
    },
    clear() {
      this.loading = false;
      this.treatPlans = [];
      this.patNum = null;
      store.dispatch('clearPatNum');
      store.dispatch('clearPatName');
    },
    selectPlan(tPlan) {
      // save TreatPlan in store to use it and to load the plan items later?
      // navigate to page to display plan
      // console.log(tPlan);
      store.dispatch('updateTreatmentPlan', tPlan);
      this.$router.push('/treatment-plan')
    },
  },
  async mounted () {
    if(this.pat_num) {
      this.patNum = this.pat_num;
    }
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.find-plans {
  padding-top: 55px;


  @media (min-width: @screen-xs-min) {
    .form-control {
      margin: 0;
    }
  }
}
.hr-salmon {
  margin-top: 0;
}
.loading-search {
  line-height: 48px;
}
.btn-tplan-select {
  background-color: @light-color;
  border: 1px solid @dim-color !important;
  text-align: left;
  padding: 20px;
  width: 100%;
  margin-bottom: 10px;

  > span {
    padding-right: 20px;
  }
  span span {
    font-size: 18px;
    line-height: 18px;
  }
  span strong {
    font-size: 16px;
    line-height: 24px;
  }
  .fas {
    text-align: right;
  }
  &:hover {
    background-color: @color-green;
    border: 3px solid @color-salmon, 1px solid @light-color !important;
  }
}
p.pat-name {
  margin: 20px 0;
}
</style>
